<template>
  <router-link
    :to="{ name: 'Star', params: { slug: star.slug } }"
    class="block w-full"
  >
    <div :title="star.name" class="h-[600px] w-full px-3 cursor-pointer group">
      <VueLoadImage class="h-[85%] w-full">
        <template v-slot:image>
          <img
            class="object-cover object-center rounded-xl h-full w-full"
            :src="star.cover_image"
            :alt="star.name"
          />
        </template>
        <template v-slot:preloader>
          <div
            class="w-full h-full text-secondary bg-black rounded-xl relative"
          >
            <SpinLoader />
          </div>
        </template>
      </VueLoadImage>

      <div class="h-[15%] flex flex-col items-center justify-center">
        <h3
          class="
            text-secondary text-center text-xl
            font-bold
            group-hover:text-accent
            transition-default
          "
        >
          {{ star.name }}
        </h3>
      </div>
    </div>
  </router-link>
</template>

<script>
import VueLoadImage from "vue-load-image";
import SpinLoader from "@/components/UI/Loader/SpinLoader";
export default {
  name: "StarItem",
  components: {
    VueLoadImage,
    SpinLoader,
  },
  props: {
    star: {
      type: Object,
      required: true,
    },
  },
  methods: {
    calculateAge(date) {
      const today = new Date();
      const birthDate = new Date(date);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
};
</script>

<style>
</style>